<div class="modal-header">
	<h4 class="modal-title">{{ mediaArticle?.title }}</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="activeModal.dismiss()"
	></button>
</div>
<div class="modal-body">
	@let videoFile = getVideoFile();
	@let audioFile = getAudioFile();

	@if (videoFile) {
		<div class="ratio ratio-16x9">
			<iframe
				[src]="getVideoUrl(videoFile) | safeUrl"
				allowfullscreen
			></iframe>
		</div>

		<!-- <button class="btn btn-primary mt-3" (click)="Transcribe()">
			Litteroi ääni
		</button> -->
		Litterointi-toiminto ei enää käytössä.

		@if (getVideoFile()!.content) {
			<div class="mt-3">
				<h5>Litterointi</h5>
				<p>{{ videoFile.content }}</p>
			</div>
		}
	}

	@if (audioFile) {
		<audio controls class="w-100">
			<source [src]="getAudioUrl(audioFile)" type="audio/mpeg" />
			Your browser does not support the audio element.
		</audio>

		<!-- <button class="btn btn-primary mt-3">Litteroi ääni</button> -->
		Litterointi-toiminto ei enää käytössä.

		@if (audioFile.content) {
			<div ngbAccordion [closeOthers]="true">
				<div ngbAccordionItem>
					<h2 ngbAccordionHeader>
						<button ngbAccordionButton>Litteroitu sisältö</button>
					</h2>
					<div ngbAccordionCollapse>
						<div ngbAccordionBody>
							<ng-template>
								<p>{{ audioFile.content }}</p>
							</ng-template>
						</div>
					</div>
				</div>
			</div>
		}
	}

	@let imageFile = getImageFile();
	@if (imageFile) {
		<div class="text-center">
			<img
				[src]="getImageUrl(imageFile) | async"
				[alt]="imageFile.title || 'Kuva'"
				class="img-fluid"
				style="max-width: 100%; max-height: 70vh; object-fit: contain"
			/>
		</div>
	}
</div>
